import { render } from "./WorkStations.vue?vue&type=template&id=60493d28&scoped=true"
import script from "./WorkStations.vue?vue&type=script&lang=js"
export * from "./WorkStations.vue?vue&type=script&lang=js"

import "./WorkStations.vue?vue&type=style&index=0&id=60493d28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60493d28"]])

export default __exports__